import React from 'react';
import { useSelector } from 'react-redux';

import { Form, DatePicker, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { formatDate } from 'utilities/common';

const initialState = {
  destination: null,
  note: '',
  schedule_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
};

export const FormInput = ({ data, isLoading, onInputChange}) => {
  const StateForm = useSelector((state) => state?.Form);
  const StateWarehouse = useSelector((state) => state?.Auth?.warehouse);

  const [{ destination, schedule_at, note }, setState] = React.useState(initialState);

  React.useEffect(() => {
    const state = {
      destination,
      note,
      schedule_at
    };

    onInputChange(state);
  }, [destination, schedule_at, note]);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      destination: data?.destination,
      note: data?.note,
      schedule_at: {
        default: new Date(data?.schedule_at),
        formatted: formatDate(data?.schedule_at, 'YYYY-MM-DD'),
      },
    }));
  }, [data])

  return isLoading ? (
    <div className="col-md-12 mb-3">
      <div className="padding-20 rounded-2 border">
        <SkeletonsForm count={2} />
      </div>
    </div>
  ) : (
    <>
      <div className="mb-3">
        <div className="padding-20 rounded-2 border row">
          <div className='col-6'>
            <div className="mb-3">
              <Select.Remote
                required
                label="Pilih Tujuan Warehouse"
                placeholder=""
                url="/wms/warehouse"
                value={destination}
                initialValue={destination?.id}
                params={{exclude_id: StateWarehouse?.id}}
                row={(d) => {
                  return {
                    value: d.id,
                    label: d.name,
                  };
                }}
                keys={destination?.id}
                onSelected={(c) => {
                  setState((prevState) => ({
                    ...prevState,
                    destination: c
                  }));
                }}
                errors={StateForm?.errors?.destination_id}
              />
            </div>

            <div className="mb-3">
              <label className="form-label required">Jadwal Pengiriman</label>
              <div
                className={
                  StateForm?.errors?.schedule_at
                  ? 'border border-danger rounded'
                  : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={schedule_at?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) => {
                    setState((prevState) => ({
                      ...prevState,
                      schedule_at: {
                        default: date,
                        formatted: formatDate(date, 'YYYY-MM-DD'),
                      },
                    }));
                  }}
                  isShowTrigger
                />
              </div>
              {StateForm?.errors?.schedule_at && (
                <div
                  className="invalid-feedback"
                  style={{ display: 'block' }}
                >
                  {StateForm?.errors?.schedule_at}
                </div>
              )}
            </div>
          </div>
          <div className='col-6'>
            <Form.Textbox
              label="Catatan"
              type="text"
              value={note}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  note: e?.target?.value,
                }))
              }
              error={StateForm?.errors?.note}
            />
          </div>
        </div>
      </div>
    </>
  );
};
